import React from 'react'
import { MessengerChat } from 'react-messenger-chat-plugin'

export const FacebookMessenger = () => {
  // We can create our own component to well control the whole feature
  // https://github.com/hueindahaus/react-messenger-chat-plugin/blob/main/src/MessengerChat/index.tsx
  return <MessengerChat pageId={"449237681825576"} themeColor={"#000000"} loggedInGreeting="loggedInGreeting" loggedOutGreeting="loggedOutGreeting" version="v15.0"/>
}
